import React, { useEffect, useState } from 'react';

import './AdjustValidationResult.scss';

const AdjustValidationResult = ({ adjustValidationResult }) => {
  return (
    <div className="reach-limit-container d-flex flex-column">
      <div className="customer-detail-prompt-content d-flex flex-row">
        <label class="limit-content-label">
          {adjustValidationResult.title}
        </label>
      </div>
      {adjustValidationResult.results?.map((result) => (
        <>
          <div className="customer-detail-prompt-content d-flex flex-row">
            <div className="dot-container">
              <div className="dot" />
            </div>
            <label class="limit-content-label">{result.title}</label>
          </div>

          <div className="d-flex flex-row">
            <div className="dot-container" />
            <div className="dot-container">
              <div className="dot" />
            </div>
            <label class="limit-content-label">{result.subTitle1}</label>
          </div>

          <div className="d-flex flex-row">
            <div className="dot-container" />
            <div className="dot-container">
              <div className="dot" />
            </div>
            <label class="limit-content-label">{result.subTitle2}</label>
          </div>
        </>
      ))}
    </div>
  );
};

export default AdjustValidationResult;
